import { Component } from '@inter-ikea-core/core';

/**
 * Component added when room changes are finished.
 * @implements {Component}
 *
 * @property {number} typeId - The unique identifier for this component type
 * @property {boolean} doStoreInSnapshot - Flag indicating if component should be stored in snapshots
 *
 * @example
 * const roomChangeFinished = new RoomChangeCompleteComponent();
 */
export default class RoomChangeCompleteComponent implements Component {
  static id = 3000;
  typeId = RoomChangeCompleteComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return false;
  }
}
